class DemandesApprenantsHelper {
    i18nService;
    #tiers;
    dateFormatterService;
    constructor(i18nService, tiers, dateFormatterService) {
        this.#tiers = tiers;
        this.i18nService = i18nService;
        this.dateFormatterService = dateFormatterService;
    }
    async formatBirthValues() {
        const values = [];
        if (this.#tiers.individu) {
            const dateNaissance = this.#tiers.individu.Naissance?.DateNaissance;
            let dateNaissanceToDisplay = '';
            if (dateNaissance) {
                const formattedDateNaissance = this.dateFormatterService.asDate(dateNaissance, { style: 'long' });
                dateNaissanceToDisplay = ` ${this.i18nService.translate('demandes-apprenants.recapitulatif.on-date', {
                    date: formattedDateNaissance,
                })}`;
            }
            const lieuNaissance = this.#tiers.individu.Naissance?.LieuNaissance?.Localite?.value;
            let formattedLieuNaissance = '';
            if (lieuNaissance) {
                formattedLieuNaissance = ` ${this.i18nService.translate('demandes-apprenants.recapitulatif.to-location', {
                    lieu: lieuNaissance,
                })}`;
            }
            if (dateNaissanceToDisplay || formattedLieuNaissance) {
                values.push({
                    label: this.i18nService.translate('demandes-apprenants.recapitulatif.born'),
                    value: `${dateNaissanceToDisplay}${formattedLieuNaissance}`.trim(),
                });
            }
            const birthName = this.#tiers.individu.Noms.NomFamille ?? '';
            if (birthName) {
                values.push({
                    label: this.i18nService.translate('demandes-apprenants.recapitulatif.birth-name'),
                    value: birthName,
                });
            }
        }
        return values;
    }
    formatAddressValues() {
        const addressObj = this.#tiers.situations?.[0];
        if (addressObj) {
            const postalCodeCityCountry = `${addressObj.geographique?.CodePostal} ${addressObj.geographique?.Localite?.value} ${addressObj.geographique?.Pays?.value}`.trim();
            const adresseElements = [
                addressObj.geographique?.PointRemise,
                addressObj.geographique?.Complement,
                addressObj.geographique?.NomVoie,
                addressObj.geographique?.MentionDistribution,
                postalCodeCityCountry,
            ].filter(Boolean);
            if (adresseElements.length > 0) {
                const adresseHtml = adresseElements.join('<br/>');
                return [
                    {
                        icon: 'location-outline',
                        value: adresseHtml,
                    },
                ];
            }
        }
        return [];
    }
    formatPhoneValue(type, icon) {
        const phoneNumber = this.#tiers.telephones?.find((phone) => phone.TYPE === type)?.value;
        if (phoneNumber) {
            return {
                icon,
                link: `tel:${phoneNumber.replaceAll(' ', '')}`,
                value: phoneNumber,
            };
        }
        return null;
    }
    formatPhoneValues() {
        return [this.formatPhoneValue('home', 'phone-outline'), this.formatPhoneValue('cell', 'mobile-outline')].filter(Boolean);
    }
    formatEmailValues() {
        const email = this.#tiers.courriels?.[0]?.value;
        if (email) {
            return [
                {
                    icon: 'mail-outline',
                    link: 'mailto:' + email,
                    value: email,
                },
            ];
        }
        return [];
    }
    async formatIdentityDetails() {
        const formattedBirthValues = await this.formatBirthValues();
        return [formattedBirthValues, this.formatAddressValues(), this.formatPhoneValues(), this.formatEmailValues()];
    }
}
export default DemandesApprenantsHelper;
//# sourceMappingURL=demandes-apprenants-helper.js.map